import React from "react"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {Body, H3} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import {User} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import styled from "styled-components"
import mainTheme from "@irati/ui/src/global/theme"
import successImage from "@irati/ui/images/success.svg"
import Icon from "@irati/ui/src/Icon"
import Markdown from "@irati/ui/src/Markdown"

interface Props {
  onHide: () => void
  onNewInvitation: () => void
  user: User
}
const InfoContainer = styled(Flex)`
  align-items: flex-start;
  gap: ${mainTheme.spacing.two};
  margin-bottom: ${mainTheme.spacing.four};
  border-radius: ${mainTheme.spacing.two};
  border: 1px solid ${mainTheme.colors.primary1_100};
  padding: ${mainTheme.spacing.two};
  background-color: ${mainTheme.colors.primary1_50};
`

export const StyledMarkdown = styled(Markdown)`
  p {
    font-size: 18px;
  }
`

export const InviteFFPopupSuccess = (props: Props) => {
  const {onHide, onNewInvitation, user} = props
  const {formatMessage} = useIntl()
  return (
    <GenericModal
      image={successImage}
      dismissButtonText="platform.button.cancel"
      proceedButtonText="wallet.familyAndFriends.popup.sendNewInvitation"
      show
      title={formatMessage({id: "wallet.familyAndFriends.popup.success.title"})}
      onConfirm={onNewInvitation}
      onHide={onHide}>
      <Body maxWidth="100%" textAlign="center" large marginBottom={mainTheme.spacing.two} marginTop={mainTheme.spacing.four}>
        <StyledMarkdown
          source={formatMessage(
            {id: "wallet.familyAndFriends.popup.success.subtitle"},
            {
              user: firstnameLastname(user),
              email: user.email
            }
          )}
        />
      </Body>
      <InfoContainer>
        <Icon icon="email" extraLarge color={mainTheme.colors.tertiary.b_400} />
        <Flex direction="column" gap={mainTheme.spacing.two} width="100%">
          <H3 color={mainTheme.colors.tertiary.b_400}>
            <FormattedMessage id="wallet.familyAndFriends.popup.success.infoTitle" />
          </H3>
          <Body maxWidth="100%" color={mainTheme.colors.tertiary.b_400}>
            <FormattedMessage
              id="wallet.familyAndFriends.popup.success.infoMsg"
              values={{
                user: firstnameLastname(user)
              }}
            />
          </Body>
        </Flex>
      </InfoContainer>
    </GenericModal>
  )
}
